import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { MyGrievanceService } from './my-grievance.service';
import { ProjectConstants} from 'src/app/grievance/project-constants'
import { CommonFunction } from '../../common-function';
import { GrievanceList } from '../../interface/common-interface';
const COLS = [
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
  { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
  { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
  { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
];

// export interface GrievanceList {
//   pkUsgrid: any;
//   boardName: any;
//   grivType: any;
//   usGriSubject: string;
//   createdOn: any;
//   updatedOn: any;
//   statusName: any;
// }
// export class GrievanceList {
//   pkUsgrid: any;
//   boardName: any;
//   grivType: any;
//   usGriSubject: string;
//   createdOn: any;
//   updatedOn: any;
//   statusName: any;
// }
@Component({
  selector: 'app-my-grievance',
  templateUrl: './my-grievance.component.html',
  styleUrls: ['./my-grievance.component.scss'],
})
export class MyGrievanceComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  loading = false
  displayedColumns: any[];
  grievanceList: GrievanceList[] = [];
  dataSource = new MatTableDataSource(this.grievanceList);
  progressSpinnerDialog: any = null;
  grievancenoData = ProjectConstants.grievanceNotAvailable;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  
  constructor(public myGrievanceService: MyGrievanceService,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    public commonFunction:CommonFunction,
    public router: Router) { }

  async ngOnInit() {
    this.displayedCols = [
      { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
      { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
      { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
    ];
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    this.dataSource.paginator = this.paginator;
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.loadGrievanceList()
  }
  //

  //load all self grievance
  async loadGrievanceList() {
    this.displayProgressSpinner();
    const response: any = await this.myGrievanceService.loadGrievanceForInternalUser()
    this.progressSpinnerDialog.close();
    if (response != null && !response.error) {
      this.progressSpinnerDialog.close();
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            // var created_date = response[i].createdOn
          var created_date = (response[i].createdOn!=null && response[i].createdOn.includes("+"))?response[i].createdOn.split("+")[0]:response[i].createdOn

            let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
            const customObj = new GrievanceList();
            customObj.pkUsgrid = response[i].pkUsgrid
            customObj.boardName = response[i].boardName
            customObj.grivType = this.text_truncate(response[i].grivType, 30, '....')
            customObj.usGriSubject = this.text_truncate(response[i].usGriSubject, 30, '....');
            customObj.createdOn = created_on
            customObj.statusName = response[i].statusName
            this.grievanceList.push(customObj)
          }
          this.dataSource.data = this.grievanceList;      
        } else if (response[0].status = ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        this.grievanceList = []    
      }
      this.displayedColumns = this.displayedCols.map((col) => col.value);
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }
  //

  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //text truncate function
  text_truncate(str, length, ending) {
    if (str != null) {
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    } else {
      return null
    }
  }
  //

  //progress bar
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
  //

  //go to view-grievance on click of view col
  gotoViewGrievance(id) {
    this.router.navigate(['secure/view-grievance/' + id])
  }
  //
}

